import { useState } from 'react';
import { Drawer } from 'antd';
import {Button} from "@radix-ui/themes";
import axios from 'axios';
function MovieDrawer({id}) {
  const accessToken = process.env.REACT_APP_TMDB_ACCESS_TOKEN;
  const [movie, setMovie] = useState({});
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };
  const fetchMovie = async (id) => {
    console.log(id);
        try {
            const res = await axios.get(`https://api.themoviedb.org/3/movie/${id}?language=en-US`, {
                headers: {
                    accept: 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            });
            console.log("Response", res.data);
            setMovie(res.data);
            setOpen(true);
        } catch (error) {
            console.error(error);
        }
    }
  return (
    <>
      <Button variant = "soft" right = "9" onClick={() => fetchMovie(id)}>
        Want to know more about this movie?
      </Button>
      <Drawer
        title={movie.title}
        closable={{ 'aria-label': 'Close Button' }}
        onClose={onClose}
        open={open}
        size='large'
      >
        <p>{movie.title}</p>
        <img src ={`https://image.tmdb.org/t/p/w500${movie.poster_path}`} />
        <p>Some contents...</p>
        <p>Some contents...</p>
      </Drawer>
    </>
  );
}
export default MovieDrawer;